import axios from "axios";
import axiosRetry from "axios-retry";
import isRetryAllowed from "is-retry-allowed";

let axiosSingleton = null;

export const axiosInstance = (() => {
  if (axiosSingleton) {
    return axiosSingleton;
  }

  axiosSingleton = axios.create({
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 30000,
  });

  axiosRetry(axiosSingleton, {
    retries: 10,
    retryCondition: (error) =>
      error.code !== "ECONNABORTED" && // Prevents retrying timed out requests
      isRetryAllowed(error), // Check whether a request can be retried based on the error.code
    retryDelay: () => 1000,
  });

  const axiosInstance = axiosSingleton;

  return axiosInstance;
})();
